<template>
    <d-form id="facebookForm" @submit.prevent="connect">
        <div class="form-group">
            <label>Access token</label>
            <d-input required v-model="accessToken" />
        </div>
        <div class="form-group">
            <label>Pixel id</label>
            <d-input required v-model="pixelId" />
        </div>
        <div class="form-group">
            <label>Event</label>
            <p class="text-muted text-sm-left help-text mb-2">We will use the selected Facebook conversion event to send your affiliate transactions generated from your Facebook Ads to your Facebook Ads manager. Need more info? Check our <a href="https://knowledge.ivanhoe.io/en/articles/75105-optimize-your-affiliate-profits-from-your-facebook-ads-account" target="_blank">blogpost</a>!</p>
            <select v-model="eventName" class="form-control">
                <option :value="eventName" v-for="eventName in eventNames">{{ eventName }}</option>
            </select>
        </div>
        <d-button theme="success" type="submit">Connect</d-button>
    </d-form>
</template>

<script>
    import { FacebookIntegrationService, ErrorService } from '@/main';
    import notification from '@/mixins/notification';
    import * as Sentry from "@sentry/browser"
    import EventNames from '@/models/integrations/facebook/eventNames.model.js'

    export default {
        name: "FacebookConnectForm",

        props: ['websiteId'],

        mixins: [notification],

        data() {
            return {
                accessToken: '',
                pixelId: '',
                eventName: '',
                eventNames: EventNames,
            }
        },

        methods: {
            async connect() {
                try {
                    await FacebookIntegrationService.connect(
                        this.websiteId,
                        this.accessToken,
                        this.pixelId,
                        this.eventName
                    )

                    this.showNotification('success', 'Alert', 'Facebook successfully connected!')
                    this.$router.go()
                } catch(e) {
                    this.showNotification('error-notification', 'Oops! We have a problem', ErrorService.getErrorMessage(e.networkError.result.errors[0]))
                    console.log(e)
                    Sentry.captureException(e);
                }
            },
        },
    }
</script>
